<script setup>
import { genUID } from '@utils/toolbox';
const props = defineProps({
	text: {
		type: String,
		required: true
	},
	disabled: {
		type: Boolean,
		default: false
	}
});

const checked = defineModel('checked', {
	type: Boolean,
	default: false
});

const uuid = genUID();

</script>

<template>
  <div
    class="filtersSwitch"
  >
    <label
      :for="uuid"
      class="abToggleSwitch abToggleSwitch--themed"
      tabindex="-1"
    >
      <span
        class="abToggleSwitch__text"
        v-html="text"
      />
      <input
        :id="uuid"
        v-model="checked"
        class="abToggleSwitch__checkbox"
        type="checkbox"
        tabindex="-1"
      >
      <span class="abToggleSwitch__control" />
    </label>
  </div>
</template>
